<template>
  <div class="dataCount">
    <div class="row">
      <div class="countItem col-lg-3 col-md-3 col-sm-6 col-xs-6">
        <img src="https://fosun-portal-oss.oss-cn-hangzhou.aliyuncs.com/onelink.mdata.main.ui.pro/data_count01.png" alt="">
        <div class="itemCon">
          <p>{{paramInfo.purchaserParam}}</p>
          <span>采购商</span>
        </div>
      </div>
      <div class="countItem col-lg-3 col-md-3 col-sm-6 col-xs-6">
        <img src="https://fosun-portal-oss.oss-cn-hangzhou.aliyuncs.com/onelink.mdata.main.ui.pro/data_count02.png" alt="">
        <div class="itemCon">
          <p>{{paramInfo.purchasingUserParam}}</p>
          <span>采购用户</span>
        </div>
      </div>
      <div class="countItem col-lg-3 col-md-3 col-sm-6 col-xs-6">
        <img src="https://fosun-portal-oss.oss-cn-hangzhou.aliyuncs.com/onelink.mdata.main.ui.pro/data_count03.png" alt="">
        <div class="itemCon">
          <p>{{paramInfo.supplierParam}}</p>
          <span>供应商</span>
        </div>
      </div>
      <div class="countItem col-lg-3 col-md-3 col-sm-6 col-xs-6">
        <img src="https://fosun-portal-oss.oss-cn-hangzhou.aliyuncs.com/onelink.mdata.main.ui.pro/data_count04.png" alt="">
        <div class="itemCon">
          <p>{{paramInfo.annualPurchaseVolumeParam}}</p>
          <span>年度采购额</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ['paramInfo'],
  methods: {
  }
}
</script>



// WEBPACK FOOTER //
// src/components/data-count/index.vue